import { COMPONENT_DSL_CALLBACK_TYPES, COMPONENT_DSL_NAMES, COMPONENT_DSL_PROP_TYPES, COMPONENT_DSL_TYPES, MENU_GROUP_NAMES, COMPONENT_SETTING_ACTION_TYPE, } from '../../../constants';
import { commonActionProps, commonBasicProps, commonStyleProps } from '../../common/commonProps';
import { BuilderComponentsMenuSettings } from './BuilderComponentsMenu.settings';
export const BuilderComponentsMenu = {
    name: COMPONENT_DSL_NAMES.BuilderComponentsMenu,
    displayName: 'Menu',
    icon: 'menu',
    type: COMPONENT_DSL_TYPES.reactImportComponent,
    componentListGroupName: MENU_GROUP_NAMES.layout,
    source: {
        importName: '@builder/components',
        codeEngineImportName: 'shared/components',
        componentName: 'Menu',
    },
    overlayOutlineWhenEmpty: true,
    schema: {
        predefineds: {
            props: {
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                },
                elevation: 4,
                target: {
                    nodes: [
                        {
                            name: COMPONENT_DSL_NAMES.div,
                            nodeName: 'MenuTarget',
                            alias: 'Menu Target',
                            props: {
                                style: {
                                    display: 'inline-flex',
                                    justifyContent: 'center',
                                },
                                children: {
                                    nodes: [
                                        {
                                            name: COMPONENT_DSL_NAMES.MaterialIconButton,
                                            props: {
                                                color: 'default',
                                                size: 'medium',
                                                label: 'Icon Button',
                                                children: {
                                                    nodes: [
                                                        {
                                                            name: COMPONENT_DSL_NAMES.BuilderComponentsIcon,
                                                            props: {
                                                                name: 'MoreVert',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        },
                    ],
                },
                content: {
                    nodes: [
                        {
                            name: COMPONENT_DSL_NAMES.ListItemSymbol,
                            props: {
                                button: true,
                                onClick: {
                                    actionType: COMPONENT_SETTING_ACTION_TYPE.closePopup,
                                },
                                listItemText: {
                                    nodes: [
                                        {
                                            name: COMPONENT_DSL_NAMES.MaterialListItemText,
                                            props: {
                                                children: {
                                                    nodes: [
                                                        {
                                                            name: COMPONENT_DSL_NAMES.Text,
                                                            props: {
                                                                children: 'List Item 1',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        },
                        {
                            name: COMPONENT_DSL_NAMES.ListItemSymbol,
                            props: {
                                button: true,
                                onClick: {
                                    actionType: COMPONENT_SETTING_ACTION_TYPE.closePopup,
                                },
                                listItemText: {
                                    nodes: [
                                        {
                                            name: COMPONENT_DSL_NAMES.MaterialListItemText,
                                            props: {
                                                children: {
                                                    nodes: [
                                                        {
                                                            name: COMPONENT_DSL_NAMES.Text,
                                                            props: {
                                                                children: 'List Item 2',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        },
                                    ],
                                },
                            },
                        },
                    ],
                },
            },
        },
        passNodeAliasToProps: true,
        dndTargetPropName: 'content',
        props: Object.assign(Object.assign(Object.assign(Object.assign({}, commonStyleProps), commonActionProps), commonBasicProps), { target: {
                type: COMPONENT_DSL_PROP_TYPES.reactNode,
                required: true,
            }, content: {
                type: COMPONENT_DSL_PROP_TYPES.callback,
                body: COMPONENT_DSL_CALLBACK_TYPES.component,
                pathToUniqueKey: [],
                args: [
                    {
                        name: 'popupState',
                        path: [0],
                    },
                ],
                required: true,
                allowedNodes: [
                    COMPONENT_DSL_NAMES.ListItemSymbol,
                    COMPONENT_DSL_NAMES.NavListItemSymbol,
                    COMPONENT_DSL_NAMES.MaterialDivider,
                ],
            }, forceOpen: {
                type: COMPONENT_DSL_PROP_TYPES.boolean,
            }, anchorOrigin: {
                type: COMPONENT_DSL_PROP_TYPES.object,
                props: {
                    vertical: {
                        type: COMPONENT_DSL_PROP_TYPES.enum,
                    },
                    horizontal: {
                        type: COMPONENT_DSL_PROP_TYPES.enum,
                    },
                },
            }, transformOrigin: {
                type: COMPONENT_DSL_PROP_TYPES.object,
                props: {
                    vertical: {
                        type: COMPONENT_DSL_PROP_TYPES.enum,
                    },
                    horizontal: {
                        type: COMPONENT_DSL_PROP_TYPES.enum,
                    },
                },
            }, elevation: {
                type: COMPONENT_DSL_PROP_TYPES.number,
            } }),
    },
    settings: BuilderComponentsMenuSettings,
};
